<!-- Light mode -->
<div
    class="flex-align-center flex-justify-center route-short-label flex whitespace-nowrap font-bold leading-5 dark:hidden dark:text-contrast-yellow"
    *ngIf="label"
    [attr.aria-label]="'ROUTE' | translate: { label: label }"
    [style.color]="resolvedTextColor"
    [style.background-color]="backgroundColor"
    [style.border-color]="borderColor"
    [style.min-width]="resolvedSize"
    [style.height]="resolvedSize"
    [ngClass]="[textSizeClass, isDisabled ? 'border border-solid' : '']"
    [rwidgetShape]="shape"
    [shapeText]="label"></div>

<!-- Dark mode -->
<div
    class="flex-align-center flex-justify-center hidden w-fit rounded-full border-[1.5px] border-solid font-bold dark:flex dark:border-contrast-yellow"
    [ngClass]="[
        textSizeClass,
        isSelected && !isDisabled ? 'bg-contrast-yellow' : '',
        !isSelected && !isDisabled ? 'bg-contrast-black' : '',
        !isDisabled ? 'border-contrast-yellow' : ''
    ]"
    [style.min-width]="resolvedSize"
    [style.height]="resolvedSize">
    <div
        class="flex items-center justify-center font-bold"
        [ngClass]="[textSizeClass, isSelected ? 'text-contrast-black' : 'text-contrast-yellow']">
        {{ label }}
    </div>
</div>
